// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Inaugration_Banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Balloon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src\\assets\\styles\\launching.css */
/* Curtain transitions */
.launch-curtain {
  position: absolute;
  z-index: 1;
  top: 0;
  width: 50vw;
  height: 100vh;
  background: darkred;
  transition: transform 6s ease-in-out;
}

.launch-curtain-left {
  left: 0;
  transform: translateX(0);
}

.launch-curtain-right {
  right: 0;
  transform: translateX(0);
}

.curtain-left,
.curtain-right {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.launch-curtain-open.launch-curtain-left {
  transform: translateX(-100%);
}

.launch-curtain-open.launch-curtain-right {
  transform: translateX(100%);
}

.launch-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  animation: fadeIn 0.5s ease-out;
  will-change: transform, opacity;
}

.launch-container {
  transition:
    opacity 2s ease,
    transform 2s ease;
}

.launch-exit {
  opacity: 0;
  transform: scale(1.05);
}

.launch-container.digital-inaugural-bg {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat
    center center/100vw 100vh !important;
  animation: none !important;
  height: 100vh;
  width: 100vw;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(1.02);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsiveness */
@media (max-width: 768px) {
  .launch-container {
    background-size: contain;
    background-attachment: scroll;
  }
}

@media (orientation: portrait) {
  .launch-container {
    background-size: contain;
  }
}

.launch-animations {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
  pointer-events: none;
}

.launch-ribbon {
  position: absolute;
  top: 50%;
  width: 100%;
  height: 10px;
  background: red;
  z-index: 3;
  transition: opacity 0.5s ease;
}

.launch-scissors {
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2rem !important;
  cursor: pointer;
  z-index: 3;
  color: red;
  background: none;
  border: none;
  padding: 0;
  text-decoration: none;
}

.launch-scissors:active,
.launch-scissors:hover {
  color: red !important;
}

.launch-balloon {
  position: absolute;
  bottom: -150px;
  width: 100px;
  height: 150px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  animation: floatUp 5s ease-out forwards;
  z-index: 5;
  opacity: 1;
  transform: translateX(-50%);
}

.launch-confetti {
  position: absolute;
  width: 8px;
  height: 8px;
  background: gold;
  opacity: 1;
  animation: confettiRise 6s linear forwards;
  z-index: 5;
}

.launch-shimmer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  background-size: 200% 200%;
  animation: shimmer 6s ease-out forwards;
  pointer-events: none;
  z-index: 6;
  opacity: 0.7;
}

.launch-scaleRotate {
  position: absolute;
  width: 30px;
  height: 30px;
  animation: scaleAndSpin 6s ease-out forwards;
  opacity: 0.8;
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
  z-index: 7;
}

.launch-hidden {
  display: none !important;
}

/* Animation keyframes */
@keyframes floatUp {
  0% {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    transform: translate(-50%, -100vh);
    opacity: 0;
  }
}

@keyframes confettiRise {
  0% {
    transform: translateY(100vh) translateX(var(--tx, 0)) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) translateX(var(--tx, 0)) rotate(360deg);
    opacity: 0;
  }
}

@keyframes shimmer {
  0% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
    opacity: 0;
  }
}

@keyframes scaleAndSpin {
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: scale(2) rotate(720deg);
    opacity: 0;
  }
}

.launch-partyPopper {
  position: absolute;
  width: 14px;
  height: 14px;
  background: radial-gradient(circle, #ff4d4d, #ffcc00, #00ccff);
  border-radius: 50%;
  animation: popExplosion 1.2s ease-out forwards;
  z-index: 9999;
}

@keyframes popExplosion {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  50% {
    transform: scale(2);
    opacity: 1;
  }
  100% {
    transform: scale(3.5);
    opacity: 0;
  }
}

.launch-rocket {
  position: absolute;
  width: 6px;
  height: 14px;
  border-radius: 3px;
  animation: rocketShoot 1.5s ease-out forwards;
}

@keyframes rocketShoot {
  0% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  60% {
    transform: translate(var(--tx), -350px) rotate(180deg);
    opacity: 1;
  }
  100% {
    transform: translate(var(--tx), 150px) rotate(360deg);
    opacity: 0;
  }
}

.launch-cracker {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  animation: crackerExplode 1.2s ease-out forwards;
}

@keyframes crackerExplode {
  0% {
    transform: rotate(var(--angle)) translateY(0);
    opacity: 1;
  }
  100% {
    transform: rotate(var(--angle)) translateY(-250px);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/launching.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE;;qBAEmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;wCACsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,yDAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,uCAAuC;EACvC,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;EAC1B,uCAAuC;EACvC,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,YAAY;EACZ;;;;;;;;;;;GAWC;EACD,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kEAAkE;IAClE,UAAU;EACZ;EACA;IACE,qEAAqE;IACrE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8DAA8D;EAC9D,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,sDAAsD;IACtD,UAAU;EACZ;EACA;IACE,qDAAqD;IACrD,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,6CAA6C;IAC7C,UAAU;EACZ;EACA;IACE,kDAAkD;IAClD,UAAU;EACZ;AACF","sourcesContent":["/* src\\assets\\styles\\launching.css */\n/* Curtain transitions */\n.launch-curtain {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  width: 50vw;\n  height: 100vh;\n  background: darkred;\n  transition: transform 6s ease-in-out;\n}\n\n.launch-curtain-left {\n  left: 0;\n  transform: translateX(0);\n}\n\n.launch-curtain-right {\n  right: 0;\n  transform: translateX(0);\n}\n\n.curtain-left,\n.curtain-right {\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.launch-curtain-open.launch-curtain-left {\n  transform: translateX(-100%);\n}\n\n.launch-curtain-open.launch-curtain-right {\n  transform: translateX(100%);\n}\n\n.launch-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  z-index: 9999;\n  opacity: 1;\n  transition: opacity 0.5s ease-in-out;\n  animation: fadeIn 0.5s ease-out;\n  will-change: transform, opacity;\n}\n\n.launch-container {\n  transition:\n    opacity 2s ease,\n    transform 2s ease;\n}\n\n.launch-exit {\n  opacity: 0;\n  transform: scale(1.05);\n}\n\n.launch-container.digital-inaugural-bg {\n  background: transparent url(\"../images/Inaugration_Banner.png\") no-repeat\n    center center/100vw 100vh !important;\n  animation: none !important;\n  height: 100vh;\n  width: 100vw;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(1.02);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsiveness */\n@media (max-width: 768px) {\n  .launch-container {\n    background-size: contain;\n    background-attachment: scroll;\n  }\n}\n\n@media (orientation: portrait) {\n  .launch-container {\n    background-size: contain;\n  }\n}\n\n.launch-animations {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.launch-ribbon {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  height: 10px;\n  background: red;\n  z-index: 3;\n  transition: opacity 0.5s ease;\n}\n\n.launch-scissors {\n  position: absolute;\n  top: 46%;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 2rem !important;\n  cursor: pointer;\n  z-index: 3;\n  color: red;\n  background: none;\n  border: none;\n  padding: 0;\n  text-decoration: none;\n}\n\n.launch-scissors:active,\n.launch-scissors:hover {\n  color: red !important;\n}\n\n.launch-balloon {\n  position: absolute;\n  bottom: -150px;\n  width: 100px;\n  height: 150px;\n  background-image: url(\"../images/Balloon.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  animation: floatUp 5s ease-out forwards;\n  z-index: 5;\n  opacity: 1;\n  transform: translateX(-50%);\n}\n\n.launch-confetti {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background: gold;\n  opacity: 1;\n  animation: confettiRise 6s linear forwards;\n  z-index: 5;\n}\n\n.launch-shimmer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.1) 0%,\n    rgba(255, 255, 255, 0.4) 50%,\n    rgba(255, 255, 255, 0.1) 100%\n  );\n  background-size: 200% 200%;\n  animation: shimmer 6s ease-out forwards;\n  pointer-events: none;\n  z-index: 6;\n  opacity: 0.7;\n}\n\n.launch-scaleRotate {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  animation: scaleAndSpin 6s ease-out forwards;\n  opacity: 0.8;\n  clip-path: polygon(\n    50% 0%,\n    61% 35%,\n    98% 35%,\n    68% 57%,\n    79% 91%,\n    50% 70%,\n    21% 91%,\n    32% 57%,\n    2% 35%,\n    39% 35%\n  );\n  z-index: 7;\n}\n\n.launch-hidden {\n  display: none !important;\n}\n\n/* Animation keyframes */\n@keyframes floatUp {\n  0% {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n  90% {\n    opacity: 0.9;\n  }\n  100% {\n    transform: translate(-50%, -100vh);\n    opacity: 0;\n  }\n}\n\n@keyframes confettiRise {\n  0% {\n    transform: translateY(100vh) translateX(var(--tx, 0)) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100vh) translateX(var(--tx, 0)) rotate(360deg);\n    opacity: 0;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 100% 100%;\n  }\n  100% {\n    background-position: 0% 0%;\n    opacity: 0;\n  }\n}\n\n@keyframes scaleAndSpin {\n  0% {\n    transform: scale(0) rotate(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(2) rotate(720deg);\n    opacity: 0;\n  }\n}\n\n.launch-partyPopper {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  background: radial-gradient(circle, #ff4d4d, #ffcc00, #00ccff);\n  border-radius: 50%;\n  animation: popExplosion 1.2s ease-out forwards;\n  z-index: 9999;\n}\n\n@keyframes popExplosion {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(2);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(3.5);\n    opacity: 0;\n  }\n}\n\n.launch-rocket {\n  position: absolute;\n  width: 6px;\n  height: 14px;\n  border-radius: 3px;\n  animation: rocketShoot 1.5s ease-out forwards;\n}\n\n@keyframes rocketShoot {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n    opacity: 1;\n  }\n  60% {\n    transform: translate(var(--tx), -350px) rotate(180deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(var(--tx), 150px) rotate(360deg);\n    opacity: 0;\n  }\n}\n\n.launch-cracker {\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  animation: crackerExplode 1.2s ease-out forwards;\n}\n\n@keyframes crackerExplode {\n  0% {\n    transform: rotate(var(--angle)) translateY(0);\n    opacity: 1;\n  }\n  100% {\n    transform: rotate(var(--angle)) translateY(-250px);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
